import React, { useState, useEffect, useRef } from 'react'
import TextField from '@mui/material/TextField'
import BarCodeScan from '@/product/components/organisms/BarCodeScan'
import { Tooltip } from '@mui/material'
import { useFormik } from 'formik'
import * as Yup from 'yup'
import { Button } from '@mui/material'

const CustomInput = (props) => {
    const shrink = props.shrink ? props.shrink.toString() : 'false'
    const inputRef = useRef(null)
    const [scanToggle, setScanToggle] = useState(false)

    const [inputValue, setInputValue] = useState('')

    const characterCount = inputValue ? inputValue.length : 0

    const handleKeyPress = (event) => {
        if (
            props.type === 'number' &&
            ['e', 'E', '+', '-'].includes(event.key)
        ) {
            event.preventDefault()
        } else if (event.key === 'Enter' || event?.keyCode === 13) {
            event.preventDefault()
            props.formik.setFieldValue(props.name, inputValue)
            if (props.formik) {
                props.formik.submitForm()
            }
        }
    }

    const handlePaste = (event) => {
        const array = ['e', 'E', '+', '-']
        let prevent = false
        let charToFind = event.clipboardData.getData('text')
        if (charToFind) {
            Array.from(charToFind).forEach((char) => {
                if (array.includes(char)) {
                    prevent = true
                }
            })
        }

        if (props.triggerPasteEvent) {
            props.formik.setFieldValue(props.name, charToFind)
            if (props.formik) {
                props.formik.submitForm()
            }
        }
        if (props.type === 'number' && prevent) {
            event.preventDefault()
        }
    }
    const capitalizeFirstLetter = (str) => {
        return str ? str.replace(/\b\w/g, (match) => match.toUpperCase()) : ''
    }

    const capitalizeAllLetter = (str) => {
        return str ? str.toUpperCase() : ''
    }

    const handleChange = (event) => {
        if (props.propercase) {
            setInputValue(capitalizeFirstLetter(event.target.value))
        } else if (props.capitalize) {
            setInputValue(capitalizeAllLetter(event.target.value))
        } else if (props.maxLength) {
            if (event.target.value.length <= props.maxLength) {
                setInputValue(event.target.value)
            }
        } else if (props.maxDecimal) {
            const regex = /^\d*\.?\d{0,2}$/
            if (regex.test(event.target.value)) {
                setInputValue(event.target.value)
            }
        } else {
            setInputValue(event.target.value)
        }
    }

    useEffect(() => {
        if (props.propercase) {
            setInputValue(capitalizeFirstLetter(props.value))
        } else if (props.capitalize) {
            setInputValue(capitalizeAllLetter(props.value))
        } else {
            setInputValue(props.value)
        }
    }, [props.value])

    useEffect(() => {
        if (props.onWheel) {
            const handleWheel = (e) => e.preventDefault()
            inputRef.current.addEventListener('wheel', handleWheel)
        }
    }, [props.onWheel])

    useEffect(() => {
        if (props.forcedAutoFocus) {
            inputRef.current.focus()
        }
    }, [props.forcedAutoFocusUpdateDependency])

    const fileValidationArray = Yup.object({
        file_path: Yup.array().when('content_type', {
            is: 'file',
            then: Yup.array().required('Required!'),
        }),
    })

    const fileFormik = useFormik({
        initialValues: {
            file_path: [],
        },
        validationSchema: fileValidationArray,
        onSubmit: (values) => {},
    })

    const changeScanDialogStatus = () => {
        fileFormik.resetForm()
        setScanToggle(!scanToggle)
    }

    const handleScanProduct = () => {
        setScanToggle(true)
    }

    const setDecodedBarcode = (item) => {
        setInputValue(item)
        // formik.values.filters.id.value = data
    }

    useEffect(() => {
        if (!props.enableAutofillCheck) return

        const handleAutofill = () => {
            if (inputRef.current?.value) {
                props.formik.setFieldValue(props.name, inputRef.current.value)
                props.formik.validateField(props.name)
            }
        }
        let timeoutId = setTimeout(handleAutofill, 300)
        const animationFrameId = requestAnimationFrame(() => {
            handleAutofill()
        })
        const intervalId = setInterval(handleAutofill, 100)
        const clearIntervalId = setTimeout(() => {
            clearInterval(intervalId)
        }, 1000)

        return () => {
            clearTimeout(timeoutId)
            cancelAnimationFrame(animationFrameId)
            clearInterval(intervalId)
            clearTimeout(clearIntervalId)
        }
    }, [props.name, props.formik, props.enableAutofillCheck])

    return (
        <div
            className={`customInput ${props.error ? 'error-input' : ''}`}
            style={props.inputStyle ? props.inputStyle : null}
        >
            {props.upperLabel ? (
                <>
                    <label htmlFor={props.id}>{props.label}</label>
                    <Tooltip
                        title={props.tooltiptitle}
                        arrow={props.tooltiptitle ? true : false}
                        placement="top"
                        disableHoverListener={true}
                        disableFocusListener={props.tooltiptitle ? false : true}
                    >
                        <TextField
                            value={inputValue}
                            autoFocus={props.autoFocus}
                            name={props.name}
                            onChange={handleChange}
                            autoComplete={props?.autoComplete}
                            onKeyDown={handleKeyPress}
                            onPaste={handlePaste}
                            onFocus={props.onFocus}
                            onBlur={props.onChange}
                            InputProps={{
                                inputProps: props.inputProps,
                                startAdornment: props.startAdornment,
                                endAdornment: (
                                    <>
                                        {props?.scanBarcode ? (
                                            <Button
                                                onClick={() =>
                                                    handleScanProduct()
                                                }
                                            >
                                                <span className="material-icons">
                                                    qr_code_scanner
                                                </span>
                                            </Button>
                                        ) : (
                                            props.endAdornment
                                        )}
                                        {props.showCounter &&
                                            (props.maxLength ||
                                                props.counterLimit) && (
                                                <span
                                                    style={{
                                                        marginLeft: '8px',
                                                        color:
                                                            props.counterLimit &&
                                                            characterCount >
                                                                props.counterLimit
                                                                ? 'red'
                                                                : 'gray',
                                                    }}
                                                >
                                                    {`(${characterCount}/${
                                                        props.maxLength ||
                                                        props.counterLimit
                                                    })`}
                                                </span>
                                            )}
                                    </>
                                ),
                                maxLength: props.maxLength,
                                readOnly: props.readonly,
                                shrink: shrink,
                                'aria-label': props.label,
                            }}
                            InputLabelProps={{
                                id: props.id,
                                name: props.label,
                                'aria-label': props.label,
                                'aria-labelledby': props.id,
                            }}
                            htmlFor={props.id}
                            id={props.id}
                            label=""
                            type={props.type}
                            size={props.size}
                            disabled={props.disabled}
                            variant={props.variant ? props.variant : 'outlined'}
                            placeholder={props.placeholder}
                            error={props.error}
                            helperText={props.helperText}
                            inputRef={inputRef}
                        />
                        <BarCodeScan
                            scanToggle={scanToggle}
                            changeScanDialogStatus={changeScanDialogStatus}
                            setDecodedBarcode={setDecodedBarcode}
                        />
                    </Tooltip>
                </>
            ) : (
                <Tooltip
                    title={props.tooltiptitle}
                    arrow={props.tooltiptitle ? true : false}
                    placement="top"
                    disableHoverListener={true}
                    disableFocusListener={props.tooltiptitle ? false : true}
                >
                    <TextField
                        value={inputValue}
                        autoFocus={props.autoFocus}
                        name={props.name}
                        onChange={handleChange}
                        onKeyDown={handleKeyPress}
                        onPaste={handlePaste}
                        onFocus={props.onFocus}
                        onBlur={props.onChange}
                        autoComplete={props?.autoComplete}
                        InputProps={{
                            inputProps: props.inputProps,
                            startAdornment: props.startAdornment,
                            endAdornment: (
                                <>
                                    {props?.scanBarcode ? (
                                        <Button
                                            onClick={() => handleScanProduct()}
                                        >
                                            <span className="material-icons">
                                                qr_code_scanner
                                            </span>
                                        </Button>
                                    ) : (
                                        props.endAdornment
                                    )}
                                    {props.showCounter &&
                                        (props.maxLength ||
                                            props.counterLimit) && (
                                            <span
                                                style={{
                                                    marginLeft: '8px',
                                                    color:
                                                        props.counterLimit &&
                                                        characterCount >
                                                            props.counterLimit
                                                            ? 'red'
                                                            : 'gray',
                                                }}
                                            >
                                                {`(${characterCount}/${
                                                    props.maxLength ||
                                                    props.counterLimit
                                                })`}
                                            </span>
                                        )}
                                </>
                            ),
                            maxLength: props.maxLength,
                            readOnly: props.readonly,
                            shrink: shrink,
                            'aria-label': props.label,
                        }}
                        InputLabelProps={{
                            id: props.id,
                            name: props.label,
                            'aria-label': props.label,
                            'aria-labelledby': props.id,
                        }}
                        htmlFor={props.id}
                        id={props.id}
                        label={props.label}
                        type={props.type}
                        size={props.size}
                        disabled={props.disabled}
                        variant={props.variant ? props.variant : 'outlined'}
                        placeholder={props.placeholder}
                        error={props.error}
                        helperText={props.helperText}
                        inputRef={inputRef}
                    />
                    <BarCodeScan
                        scanToggle={scanToggle}
                        changeScanDialogStatus={changeScanDialogStatus}
                        setDecodedBarcode={setDecodedBarcode}
                    />
                </Tooltip>
            )}
        </div>
    )
}

export default CustomInput
